<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Tagi - Ecommerce</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Tagi - Ecommerce</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Tagi śledzenia</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddTrackingTag" to="/tracking-tags/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="control-label">Wpisz liczbę wierszy:</label>
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
                <div class="col-sm-4 domain-select" v-if="sitesOptions.length">
                  <div class="form-group">
                    <label class="control-label">Domena</label>
                    <Multiselect
                      v-model="filterSitePk"
                      :options="sitesOptions"
                      placeholder="Wybierz domenę"
                      track-by="name"
                      label="name"
                      mode="single"
                      :close-on-select="true"
                      :searchable="true"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editTag"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #item-is_active="item">
                    {{ item.is_active ? "Aktywny" : "Nieaktywny" }}
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteTrackingTag"
                      @click.stop="deleteTag(item)"
                      class="btn btn-danger btn-xs"
                      title="Usuń"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis tagu [pl]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isPlOpen = !isPlOpen"
                            >
                              <i :class="chevronPlClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isPlOpen">
                            <div class="form-group">
                              <label>Nazwa</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="tagObj.name"
                                required
                              />
                            </div>
                            <div class="form-group">
                              <label>Typ</label>
                              <Multiselect
                                :key="`type-${tagObj.type?.value || 'empty'}`"
                                :modelValue="tagObj.type"
                                @update:modelValue="
                                  (value) => (tagObj.type = value)
                                "
                                :options="typeOptions"
                                :searchable="true"
                                :create-option="false"
                                placeholder="Wybierz typ"
                                track-by="value"
                                label="label"
                                mode="single"
                                required
                              />
                            </div>
                            <div class="form-group">
                              <label>Identyfikator</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="tagObj.identifier"
                                required
                              />
                            </div>
                            <div class="form-group">
                              <label>Lokalizacja</label>
                              <Multiselect
                                :key="`location-${
                                  tagObj.location?.value || 'empty'
                                }`"
                                :modelValue="tagObj.location"
                                @update:modelValue="
                                  (value) => (tagObj.location = value)
                                "
                                :options="locationOptions"
                                :searchable="true"
                                :create-option="false"
                                placeholder="Wybierz lokalizację"
                                track-by="value"
                                label="label"
                                mode="single"
                                required
                              />
                            </div>
                            <div class="form-group">
                              <label>Kod śledzenia</label>
                              <textarea
                                class="form-control"
                                v-model="tagObj.code_snippet"
                                rows="6"
                                required
                              ></textarea>
                            </div>
                            <div class="form-group">
                              <div class="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    v-model="tagObj.is_active"
                                  />
                                  Tag aktywny
                                </label>
                              </div>
                            </div>
                            <div class="form-group">
                              <button class="btn btn-white" @click="cancel">
                                Anuluj
                              </button>
                              <button
                                v-if="canChangeTrackingTag"
                                @click="saveEdit"
                                class="btn btn-primary"
                              >
                                Zapisz
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="deletePk"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć tag <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteConf(deletePk)"
    @callbackClose="deletePk = null"
  />
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { trackingTagPermissionsConst } from "../../constants/tagsConstants";
import EasyDataTable from "vue3-easy-data-table";
import Modal from "../caffeprint/Modal.vue";
import "vue3-easy-data-table/dist/style.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";

export default {
  name: "TrackingTagsList",
  components: {
    EasyDataTable,
    Modal,
    Multiselect,
  },
  setup() {
    const store = useStore();
    const canAddTrackingTag = computed(() =>
      hasPermission(trackingTagPermissionsConst.add)
    );
    const canChangeTrackingTag = computed(() =>
      hasPermission(trackingTagPermissionsConst.update)
    );
    const canDeleteTrackingTag = computed(() =>
      hasPermission(trackingTagPermissionsConst.delete)
    );
    const loading = ref(false);
    const items = ref([]);
    const itemsAll = ref(0);
    const rowsPerPage = ref(25);
    const isSearch = ref(false);
    const tagObj = ref({});
    let pendingEdit = null;

    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
      sortBy: "name",
      sortType: "asc",
    });

    const isMainOpen = ref(true);
    const isPlOpen = ref(true);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const headers = [
      { text: "Nazwa", value: "name", sortable: true },
      { text: "Typ", value: "type", sortable: true },
      { text: "Identyfikator", value: "identifier", sortable: true },
      { text: "Lokalizacja", value: "location", sortable: true },
      { text: "Status", value: "is_active", sortable: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    const typeOptions = ref([]);
    const locationOptions = ref([]);
    // Domain filter state
    const filterSitePk = ref(null);
    const sitesOptions = ref([]);
    const siteFilterInitialized = ref(false);

    const trackingTagsData = computed(() => store.getters.getTrackingTagsData);
    const createTrackingTagData = computed(
      () => store.getters.getCreateTrackingTagData
    );
    const updateTrackingTagData = computed(
      () => store.getters.getUpdateTrackingTagData
    );
    const deleteTrackingTagData = computed(
      () => store.getters.getDeleteTrackingTagData
    );
    const trackingTagsTypeOpts = computed(
      () => store.getters.getTrackingTagsTypeOpts
    );
    const trackingTagsLocationOpts = computed(
      () => store.getters.getTrackingTagsLocationOpts
    );
    const sitesData = computed(() => store.getters.getSitesData);

    const getTrackingTags = () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      store.dispatch("getTrackingTags", {
        page: serverOptions.value.page,
        page_size: serverOptions.value.rowsPerPage,
        ordering:
          serverOptions.value.sortBy +
          (serverOptions.value.sortType === "desc" ? "-" : ""),
        site_pk: filterSitePk.value,
      });
    };

    const getOptions = () => {
      store.dispatch("getTrackingTagsTypeOpts");
      store.dispatch("getTrackingTagsLocationOpts");
      store.dispatch("getSites");
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = parseInt(rowsPerPage.value);
      serverOptions.value.page = 1;
      getTrackingTags();
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
      getTrackingTags();
    };

    const resetFilters = () => {
      serverOptions.value.page = 1;
      serverOptions.value.sortBy = "name";
      serverOptions.value.sortType = "asc";
      filterSitePk.value = null;
      getTrackingTags();
    };

    const editTag = (rowIndex) => {
      const item = items.value[rowIndex];
      if (!item) return;
      pendingEdit = { ...item };
      trySetTagObj();
    };

    const trySetTagObj = () => {
      if (!pendingEdit) return;
      if (typeOptions.value.length && locationOptions.value.length) {
        tagObj.value = { ...pendingEdit };
        tagObj.value.type = pendingEdit.type || null;
        tagObj.value.location = pendingEdit.location || null;

        pendingEdit = null;
      }
    };

    watch(() => typeOptions.value, trySetTagObj);
    watch(() => locationOptions.value, trySetTagObj);

    const saveEdit = () => {
      if (!canChangeTrackingTag.value) {
        return;
      }
      store.dispatch("updateTrackingTag", tagObj.value);
    };

    // Deleting asks for a confirmation in the modal, like the other lists.
    const deletePk = ref(null);
    const deleteName = ref("");

    const deleteTag = (item) => {
      if (!canDeleteTrackingTag.value) {
        return;
      }
      deleteName.value = item.name;
      deletePk.value = item.pk;
    };

    const deleteConf = (pk) => {
      deletePk.value = null;
      if (!canDeleteTrackingTag.value || !pk) {
        return;
      }
      store.dispatch("deleteTrackingTag", { pk });
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    watch(
      () => trackingTagsData.value,
      function (newValue) {
        if (newValue && newValue.status === 200) {
          itemsAll.value = newValue.data.count;
          items.value = newValue.data.results || [];
          loading.value = false;
        }
      }
    );

    watch(
      () => createTrackingTagData.value,
      function (newValue) {
        if (newValue && newValue.status === 201) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tag śledzenia został dodany",
          });
          getTrackingTags();
        } else if (newValue && newValue.status && newValue.status !== 201) {
          var msg = [];
          if (newValue.data) {
            for (const [key, value] of Object.entries(newValue.data)) {
              msg.push(key + ": " + value);
            }
          }
          store.dispatch("showToaster", {
            type: "error",
            content:
              msg.length > 0 ? msg[0] : "Błąd podczas dodawania tagu śledzenia",
          });
        }
      }
    );

    watch(
      () => updateTrackingTagData.value,
      function (newValue) {
        if (newValue && newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tag śledzenia został zaktualizowany",
          });
          tagObj.value = {};
          getTrackingTags();
        } else if (newValue && newValue.status && newValue.status !== 200) {
          var msg = [];
          if (newValue.data) {
            for (const [key, value] of Object.entries(newValue.data)) {
              msg.push(key + ": " + value);
            }
          }
          store.dispatch("showToaster", {
            type: "error",
            content:
              msg.length > 0
                ? msg[0]
                : "Błąd podczas aktualizacji tagu śledzenia",
          });
        }
      }
    );

    watch(
      () => deleteTrackingTagData.value,
      function (newValue) {
        if (newValue && newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tag śledzenia został usunięty",
          });
          getTrackingTags();
        } else if (newValue && newValue.status && newValue.status !== 204) {
          store.dispatch("showToaster", {
            type: "error",
            content: "Błąd podczas usuwania tagu śledzenia",
          });
        }
      }
    );

    watch(
      () => trackingTagsTypeOpts.value,
      function (newValue) {
        if (newValue) {
          typeOptions.value = [];
          newValue.data.data.forEach((item) => {
            typeOptions.value.push({
              value: item.value,
              label: item.name,
            });
          });
        }
      }
    );

    watch(
      () => trackingTagsLocationOpts.value,
      function (newValue) {
        if (newValue) {
          locationOptions.value = [];
          newValue.data.data.forEach((item) => {
            locationOptions.value.push({
              value: item.value,
              label: item.name,
            });
          });
        }
      }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        const raw = Array.isArray(newValue?.data?.results)
          ? newValue.data.results
          : Array.isArray(newValue?.data?.data)
          ? newValue.data.data
          : Array.isArray(newValue?.data)
          ? newValue.data
          : [];
        sitesOptions.value = raw.map((s) => ({ name: s.name, value: s.pk }));

        if (!hasSiteOptionValue(sitesOptions.value, filterSitePk.value)) {
          const defaultSiteValue = getSiteValueFromCurrentUrl(
            sitesOptions.value
          );
          if (defaultSiteValue !== null) {
            filterSitePk.value = defaultSiteValue;
          }
        }

        if (!siteFilterInitialized.value) {
          siteFilterInitialized.value = true;
          getTrackingTags();
        }
      }
    );

    watch(
      () => filterSitePk.value,
      function () {
        serverOptions.value.page = 1;
        getTrackingTags();
      }
    );

    onMounted(() => {
      getOptions();
    });

    return {
      canDeleteTrackingTag,
      deletePk,
      deleteName,
      deleteConf,
      canAddTrackingTag,
      canChangeTrackingTag,
      loading,
      items,
      itemsAll,
      rowsPerPage,
      isSearch,
      serverOptions,
      headers,
      typeOptions,
      locationOptions,
      tagObj,
      setRowsPerPage,
      selectPage,
      resetFilters,
      editTag,
      saveEdit,
      deleteTag,
      cancel,
      isMainOpen,
      isPlOpen,
      chevronMainClass,
      chevronPlClass,
      filterSitePk,
      sitesOptions,
    };
  },
};
</script>

<style scoped>
.modal.show {
  background-color: rgba(0, 0, 0, 0.5);
}
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
.domain-select {
  position: relative;
}
.domain-select :deep(.multiselect) {
  z-index: 3000;
}
.domain-select :deep(.multiselect-dropdown) {
  z-index: 3000;
}
</style>
